import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';

// Initialize the 3D module
Highcharts3D(Highcharts);

function GateWayInvoiceAmount({ data, currency }) {
  const options = {
    chart: {
      type: 'column',
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 0,
        depth: 30,
        viewDistance: 25
      }
    },
    title: {
      text: 'Overall Payment Gateways Revenue'
    },
    tooltip: {
      valuePrefix: `${currency} `,
      valueSuffix: ''
    },
    accessibility: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'Amount',
        x: -10
      }
    },
    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [-45, -90],
        style: {
          fontSize: '13px'
        }
      }
    },
    plotOptions: {
      column: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 35,
        dataLabels: {
          enabled: true,
          format: `<b>${currency}</b> {point.y}`
        },
        showInLegend: false
      }
    },
    series: [
      {
        type: 'column',
        name: 'Amount',
        colorByPoint: true,
        data
      }
    ]
  };

  return (
    <Box>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
}

GateWayInvoiceAmount.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      y: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
      // Add other properties expected in the object
    })
  ).isRequired,
  currency: PropTypes.string.isRequired
};

export default GateWayInvoiceAmount;
